var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    ref: "rootRef",
    class: _vm.$style.HeaderLoyaltyButton,
    on: {
      "mouseleave": _setup.handlerCloseContent,
      "mouseenter": _setup.handlerOpenContent
    }
  }, [_c(_setup.LoyaltyButton, {
    attrs: {
      "is-show-mobile": _vm.isShowMobile
    }
  }), _vm._v(" "), _vm.isShowMobile && _setup.isShowLoyaltyDayDowngradeStatus ? _c(_setup.STooltip, _vm._b({
    class: _vm.$style.info,
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c(_setup.SIcon, {
          attrs: {
            "icon": "info",
            "size": 20
          }
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function fn() {
        return [_c(_setup.DowngradeLoyaltyStatus)];
      },
      proxy: true
    }], null, false, 2375481698)
  }, 'STooltip', _setup.tooltipOptions, false)) : _vm._e(), _vm._v(" "), _setup.downgradeContentOpen ? _c(_setup.DowngradeLoyaltyStatus, {
    class: _vm.$style.downgradeStatus
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };